// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2gkOM","rootSmall":"AddTileButton_rootSmall__F8Cdn"};